import { AppConstants } from "../../../../core/constants/constants";
import InfoNotificationAlert from "../../domain/entities/InfoNotificationAlert";
import { AdminSocketRepository } from "../../domain/repositories/AdminSocketRepository";
import { AdminSocketDataSource } from "../datasource/AdminSocketDataSource";

export class AdminRepositorySocketImpl implements AdminSocketRepository {
	constructor(private dataSource: AdminSocketDataSource) {}

	connectSocket(): Promise<void> {
		return AppConstants.getRightOrLeftSide<void>(
			this.dataSource.connectSocket()
		);
	}

	disconnectSocket(): Promise<void> {
		return AppConstants.getRightOrLeftSide<void>(
			this.dataSource.disconnectSocket()
		);
	}

	onNotificationAlert(
		callback: (data: InfoNotificationAlert) => void
	): void {
		this.dataSource.onNotificationAlert(callback);
	}
}
